// extracted by mini-css-extract-plugin
module.exports = {"gamificationEntry":"gamificationEntry_gamificationEntry__U0XzH"};